import { createRouter, type RouterHistory } from '@tanstack/react-router';

import { indexRoute, newRunRoute, rootRoute, runDetailRoute } from './routes';

const routeTree = rootRoute.addChildren([indexRoute, newRunRoute, runDetailRoute]);

// Standalone dev uses the real browser history at aistudio's calibration
// route basepath. The federation mount (federation-app.tsx) calls this with
// a memory-history and an empty basepath instead, since its routes are
// exchanged host-relative and the host's vue-router owns the browser URL.
export function createAppRouter(
  history?: RouterHistory,
  basepath = '/ai-agent/monitor/calibration'
) {
  return createRouter({
    routeTree,
    basepath,
    defaultNotFoundComponent: () => <div>Page not found</div>,
    ...(history && { history }),
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

export const router = createAppRouter();

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
